import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OriginalDruckOffen = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/zertifikat-original-druck-offen`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <Card className="card-custom mb-4 border-sky-300" data-testid="original-druck-offen-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2 text-sky-800">
          <Printer size={18} /> Original noch auf Edelpapier drucken ({items.length})
        </CardTitle>
        <p className="text-xs text-stone-500">Digital verschickt – bitte in der Teilnehmerakte (Tab Zertifikat) „Drucken" klicken. Nummer und Datum bleiben gleich.</p>
      </CardHeader>
      <CardContent className="pt-0">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-stone-500 border-b">
              <th className="py-1">Teilnehmer</th><th>Kurs</th><th>Zertifikats-Nr.</th><th>Ausgestellt am</th><th>Digital am</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it, i) => (
              <tr key={`${it.teilnehmer_id}-${it.kurs_id}`} className="border-b last:border-0" data-testid={`original-offen-row-${i}`}>
                <td className="py-1.5 font-medium">{it.teilnehmer_name}</td>
                <td>{it.kurs_name || "—"}</td>
                <td className="font-mono">{it.zertifikatsnummer}</td>
                <td>{it.ausgestellt_am || "—"}</td>
                <td>{it.digital_am || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
